export { default } from './CollectionBlock';
